const DAYS = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];
const MONTHS = [
  "janvier", "février", "mars", "avril", "mai", "juin",
  "juillet", "août", "septembre", "octobre", "novembre", "décembre",
];

export const pad = (n) => String(n).padStart(2, "0");

export const toStr = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

export const todayStr = () => toStr(new Date());

export const parseStr = (s) => {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
};

export const addDays = (base, n) => {
  const d = base instanceof Date ? new Date(base) : parseStr(base);
  d.setDate(d.getDate() + n);
  return d;
};

// Lundi de la semaine contenant `date`
export const mondayOf = (date) => {
  const d = new Date(date);
  const day = (d.getDay() + 6) % 7; // 0 = lundi
  d.setDate(d.getDate() - day);
  d.setHours(0, 0, 0, 0);
  return d;
};

export const weekDays = (baseDate = new Date()) => {
  const monday = mondayOf(baseDate);
  return DAYS.map((label, i) => {
    const d = new Date(monday);
    d.setDate(monday.getDate() + i);
    return { label, date: toStr(d), dayNum: d.getDate(), month: MONTHS[d.getMonth()] };
  });
};

export const weekRange = (baseDate = new Date()) => {
  const days = weekDays(baseDate);
  return { start: days[0].date, end: days[6].date, days };
};

export const prettyDate = (s) => {
  const d = parseStr(s);
  return `${DAYS[(d.getDay() + 6) % 7]} ${d.getDate()} ${MONTHS[d.getMonth()]}`;
};

export const dayLabel = (s) => DAYS[(parseStr(s).getDay() + 6) % 7];
